import React, { PropsWithChildren } from "react";

const GridList: React.FC<PropsWithChildren> = ({ children }) => (
  <div className={"grid grid-cols-8 gap-4"}>{children}</div>
);

export default GridList;
